/**
 * Prepares an email that was sent to a customer for display in a sandboxed
 * iframe, so viewing it can never act on the customer's behalf. Scripts, meta
 * refreshes and anything that fetches another page go, forms lose their
 * action, and links lose their destination so they can't be opened at all.
 * Styles and remote images are kept so the email looks as it did to the
 * customer.
 */
export const toInertEmailHtml = (html: string): string => {
  const email = new DOMParser().parseFromString(html, "text/html")

  email
    .querySelectorAll(
      [
        "script",
        'meta[http-equiv="refresh" i]',
        // Each of these would fetch another URL (an unsubscribe link, say)
        // just by being rendered.
        "iframe",
        "frame",
        "object",
        "embed",
        'link[rel~="prefetch" i]',
        'link[rel~="prerender" i]',
      ].join(", "),
    )
    .forEach((element) => element.remove())
  // Links lose their destination entirely: the sandbox stops a plain click,
  // but Cmd/Ctrl-click, middle-click and "Open link in new tab" are browser
  // actions it can't stop, and a link like "Reset your password" carries a
  // live token for the customer's account.
  email.querySelectorAll("a, area").forEach((link) => {
    link.removeAttribute("href")
    link.removeAttribute("xlink:href")
  })
  email
    .querySelectorAll("form")
    .forEach((form) => form.removeAttribute("action"))

  const plainLinks = email.createElement("style")
  plainLinks.textContent =
    "a, area { pointer-events: none !important; cursor: default !important; }"
  email.head.append(plainLinks)

  return `<!DOCTYPE html>${email.documentElement.outerHTML}`
}
